import React, { FC } from 'react'
import { Alert, Box, Button } from '@mui/material'
import { getSelectedOrder } from 'orders/orders/redux'
import { useAppSelector } from 'store/hooks'
import { Trans, useTranslation } from 'translations'

export const FillDetailsAlert: FC = () => {
    const { t } = useTranslation()
    const order = useAppSelector(getSelectedOrder)

    if (!order?.unfilledApf) {
        return null
    }

    return (
        <Box display="flex" justifyContent="center" width="100%" mt={2}>
            <Alert
                severity="warning"
                action={
                    <Button color="primary" size="small" href={order.unfilledApfUrl}>
                        {t('orders.orders.fillDetails.button')}
                    </Button>
                }
            >
                <Trans i18nKey="orders.orders.fillDetails.alert" components={{ b: <strong /> }} />
            </Alert>
        </Box>
    )
}
